import { partial } from '../../../util/translation/translation';

const validateMessageTemplate = (values) => {
  const p = partial('validateErrors');
  const errors = {};
  if (!values.title) {
    errors.title = `${p('titleFieldCantBeEmpty')}`;
  }

  if (!values.text) {
    errors.text = `${p('messageFieldCantBeEmpty')}`;
  }

  return errors;
};

export default validateMessageTemplate;
